import React from "react";
import {Redirect, useLocation} from "react-router-dom";
import {PAGE_URLS} from "constants/AppConstants";
import {useAuth} from "contexts/AuthContext";

/**
 * /pay: a payment link (?link=…) or a Paddle transaction (?_ptxn=…) opens on the
 * onboarding. A bare /pay sends a signed-in user to their account with the paywall
 * open, and everyone else to the onboarding's sign-up options.
 */
function PayRedirect() {
  const {search} = useLocation();
  const {user, isAuthenticating} = useAuth();
  const params = new URLSearchParams(search);
  const carriesOffer = params.has("link") || params.has("_ptxn");

  if (carriesOffer) {
    return <Redirect to={{pathname: PAGE_URLS.onboardingPageUrl, search}} />;
  }
  if (isAuthenticating) {
    return null;
  }
  if (user) {
    return <Redirect to={{pathname: PAGE_URLS.myAccountPageUrl, search: "?paywall=1"}} />;
  }
  return <Redirect to={{pathname: PAGE_URLS.onboardingPageUrl, search: "?step=options"}} />;
}

export default PayRedirect;
